// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { productAttributesStyles } from "@stoneage/Overrides/Components/ProductAttributes";
import { css } from "styled-components";
import { fontConfig } from "@stoneage/XDL/constants";

const labelFont = {
    ...fontConfig.xSmallSingleLine,
    weight: fontConfig.weight.regular,
};

productAttributesStyles.itemContainer = {
    css: css`
        display: flex;
        flex-direction: row;
        align-items: flex-start;
        gap: 0;
    `,
};

/* label cell — width comes from the sizer, not from Truncate */
productAttributesStyles.attributeTypeGridItem = {
    css: css`
        position: relative;
        display: block;
        flex: 0 1 auto;
        min-width: 0;
        max-width: 60%;
        overflow: hidden;
    `,
};

productAttributesStyles.attributeTypeSizer = {
    ...labelFont,
    css: css`
        display: block;
        white-space: nowrap;
        visibility: hidden;
    `,
};

productAttributesStyles.attributeTypeText = {
    ...labelFont,
    css: css`
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
    `,
};

productAttributesStyles.attributeTypeColon = {
    ...labelFont,
    css: css`
        flex: 0 0 auto;
        margin-left: -4px;
    `,
};

productAttributesStyles.attributeValueGridItem = {
    css: css`
        display: flex;
        flex: 1 1 auto;
        min-width: 0;
        overflow: hidden;
    `,
};

productAttributesStyles.attributeValueText = {
    ...fontConfig.xSmallSingleLine,
    weight: fontConfig.weight.medium,
    css: css`
        width: 100%;
    `,
};
